<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <div class="col-md-3 text-center text-md-right order-md-2">
        <div v-if="organisation.logo" class="pt-2">
          <v-lazy-image :src="organisation.logo" class="img-fluid" />
        </div>
      </div>
      <div class="col-md-9">
        <form-base
          :submit-status="submitStatus"
          action="Update"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
          class="py-5"
        >
          <template v-slot:fields>
            <div>
              <b-tabs content-class="mt-3">
                <b-tab title="General" active>
                  <form-group label="Currency Symbol" :required="true">
                    <input
                      type="text"
                      class="form-control"
                      v-model="organisation.parameters.currency"
                    />
                  </form-group>

                  <!-- <form-group label="Domain" :required="true">
                    <input
                      type="text"                    
                      class="form-control"
                      v-model="organisation.parameters.domain"
                    />
                  </form-group> -->
                </b-tab>
                <b-tab title="Email">
                  <b-alert variant="info" show>
                    <b-media>
                      <template #aside>
                        <i class="lni lni-bulb font-size-26"></i>
                      </template>
                      <ul>
                        <li>
                          To optionally send emails from your own email account,
                          enter your SMTP details below.
                        </li>
                      </ul>
                    </b-media>
                  </b-alert>

                  <form-group label="SMTP (Host)" :required="true">
                    <input
                      type="text"
                      class="form-control"
                      v-model="organisation.parameters.mail_host"
                    />
                  </form-group>

                  <form-group label="Port" :required="true">
                    <input
                      type="text"
                      class="form-control"
                      v-model="organisation.parameters.mail_port"
                    />
                  </form-group>

                  <form-group label="Encryption">
                    <b-form-select
                      v-model="organisation.parameters.mail_encryption"
                      :options="encryption"
                    ></b-form-select>
                  </form-group>

                  <form-group label="SMTP Username">
                    <input
                      type="text"
                      class="form-control"
                      v-model="organisation.parameters.mail_username"
                    />
                  </form-group>

                  <form-group label="SMTP Password">
                    <input
                      type="text"
                      class="form-control"
                      v-model="organisation.parameters.mail_password"
                    />
                  </form-group>

                  <form-group label="From Address" :required="true">
                    <input
                      type="text"
                      class="form-control"
                      v-model="organisation.parameters.mail_from_address"
                    />
                  </form-group>

                  <form-group label="From Name" :required="true">
                    <input
                      type="text"
                      class="form-control"
                      v-model="organisation.parameters.mail_from_name"
                    />
                  </form-group>
                </b-tab>
              </b-tabs>
            </div>
          </template>
        </form-base>
      </div>
    </b-row>
  </div>
</template>

<script>
import organisationRepo from "@/api/repos/organisationRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup,
  },

  validations: {
    organisation: {
      parameters: {
        currency: {
          required,
        },
      },
    },
  },

  mounted() {
    this.getOrganisation();
  },

  data() {
    return {
      roles: [],
      organisation: {
        parameters: {},
      },
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
      encryption: [
        { value: null, text: "None" },
        { value: "tls", text: "tls" },
        { value: "ssl", text: "ssl" },
      ],
    };
  },

  methods: {
    async getOrganisation() {
      try {
        this.loading = true;
        let { data } = await organisationRepo.get(
          localStorage.getItem("current_organisation_id")
        );
        this.organisation = data.organisation;
        this.roles = data.roles;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$root.$bvToast.toast("Complete all required fields", {
          title: "Error",
          autoHideDelay: 3000,
          variant: "danger",
        });
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await organisationRepo.update(this.id, this.organisation);
          this.$root.$bvToast.toast("Organisation Updated", {
            title: "Success",
            autoHideDelay: 3000,
            variant: "success",
          });
          this.$router.push({ name: "organisations" });
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>
